// Per-tab "Save & Completed" validation for the Planning detail flow.
//
// Each function returns an array of human-readable error messages (empty = OK),
// so the caller can both decide completion and surface every problem in one toast.
// These mirror the server-side guards in the contract so the user sees them
// before the request rather than as a 422 after it.

const isBlankHtml = v =>
  !v ||
  v === '<br>' ||
  !String(v)
    .replace(/<[^>]*>/g, '')
    .trim();

// Requirement tab (contract section 6, stepStatus=Completed guards):
// contract type + both periods, end after start, ≥1 cargo, every cargo has ≥1
// Crude/Condensat, and a summary note for every clause.
export const validateRequirement = detail => {
  const r = detail.requirement || {};
  const errors = [];

  if (!r.contractType) errors.push('Contract Type is required');
  if (!r.startPeriod) errors.push('Start Period is required');
  if (!r.endPeriod) errors.push('End Period is required');
  if (
    r.startPeriod &&
    r.endPeriod &&
    new Date(r.endPeriod) <= new Date(r.startPeriod)
  ) {
    errors.push('End Period must be after Start Period');
  }
  if (!r.cargos || r.cargos.length === 0) {
    errors.push('At least one cargo must be added');
  } else {
    r.cargos.forEach(c => {
      if (!c.crudes || c.crudes.length === 0) {
        errors.push(
          `Cargo "${c.cargoType}" needs at least one Crude/Condensat`
        );
      }
    });
  }
  (r.clauses || []).forEach(c => {
    if (isBlankHtml(c.summernote)) {
      errors.push(`Summary Note is required for clause "${c.title}"`);
    }
  });

  return errors;
};

// Add Crude/Condensat popup: Max Capacity is required, numeric, non-negative,
// and may not exceed the crude's Technical Limit (`technicalLimit` from the
// LookupImplementationCrude row — the server enforces the same bound, section 10).
export const validateCrudeCapacity = row => {
  const errors = [];
  const { maxCapacity, technicalLimit } = row;

  if (maxCapacity === null || maxCapacity === '' || maxCapacity === undefined) {
    errors.push('Max Capacity is required');
    return errors;
  }
  const value = Number(maxCapacity);
  if (Number.isNaN(value)) {
    errors.push('Max Capacity must be a number');
  } else if (value < 0) {
    errors.push('Max Capacity cannot be negative');
  } else if (
    technicalLimit !== null &&
    technicalLimit !== undefined &&
    value > Number(technicalLimit)
  ) {
    errors.push(
      `Max Capacity cannot exceed the Technical Limit (${technicalLimit})`
    );
  }

  return errors;
};

// Supporting Document tab (contract section 17): at least one document.
export const validateSupporting = detail => {
  const docs = detail.supportingDocuments || [];
  return docs.length === 0 ? ['At least one document must be uploaded'] : [];
};

// DMUT Invitation tab: untuk Pelelangan Khusus (satu-satunya mekanisme yang
// didukung saat ini) SEMUA baris DMUT hasil generate wajib diundang — bukan
// sekadar minimal satu. Bila kelak mekanisme lain didukung, longgarkan per
// procurementMethod.
export const validateDmut = detail => {
  const rows = detail.dmut?.rows || [];
  if (!rows.length) {
    return [
      'Generate the Registered Supplier list first — at least one Registered Supplier is required',
    ];
  }
  const uninvited = rows.filter(r => !r.invited).length;
  return uninvited === 0
    ? []
    : [
        `Pelelangan Khusus requires ALL generated Registered Supplier to be invited — ${uninvited} row(s) still unchecked`,
      ];
};

export const VALIDATORS = {
  requirement: validateRequirement,
  supportingDocument: validateSupporting,
  dmut: validateDmut,
};
